import i18n from 'i18next';

import it from './it/translations.json';
import en from './en/translations.json';
import de from './de/translations.json';
import es from './es/translations.json';
import fr from './fr/translations.json';
import pr from './pr/translations.json';
import kr from './kr/translations.json';
import jp from './jp/translations.json';
import sc from './sc/translations.json';
import tc from './tc/translations.json';

const STORAGE_KEY = 'i18n-lang';

i18n.init({
    fallbackLng: 'en',

    // have a common namespace used around the full app
    ns: ['translations'],
    defaultNS: 'translations',
    lng: localStorage.getItem(STORAGE_KEY) || 'en',
    resources: {
        en,
        it,
        de,
        es,
        fr,
        pr,
        kr,
        jp,
        sc,
        tc,
    },

    debug: true,

    interpolation: {
        escapeValue: false, // not needed for react!!
    },

    react: {
        wait: false,
    },
});

export default i18n;

i18n.on('languageChanged', lng => localStorage.setItem(STORAGE_KEY, lng));



// WEBPACK FOOTER //
// ./src/locales/i18n.js